import { render, staticRenderFns } from "./EditableCard.vue?vue&type=template&id=4adc7765&scoped=true&"
import script from "./EditableCard.vue?vue&type=script&lang=js&"
export * from "./EditableCard.vue?vue&type=script&lang=js&"
import style0 from "./EditableCard.vue?vue&type=style&index=0&id=4adc7765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc7765",
  null
  
)

export default component.exports